<template>
  <div style="height:100%">
    <TwHeader>
      <template #left>
        <tw-breadcrumbs :pages="breadcrumbs" class="mb-2" />
      </template>
    </TwHeader>

    <div class="py-4 px-8">
      <div v-if="isNew">
        <AddFlow />
      </div>
      <div v-else>
        <FlowDetail />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { defineComponent, ref, computed } from '@vue/composition-api';
import { LANGUAGE_CODE } from 'lib-tw-common';

import TwBreadcrumbs from '@/components/molecules/TwBreadcrumbs';

import TwHeader from '@/components/vue3/TwHeader.vue';

import AddFlow from './components/DetailAddFlow.vue';
import FlowDetail from './components/DetailFlow.vue';

export default defineComponent({
  name: 'TradingFlowDetail',
  components: {
    TwBreadcrumbs,
    TwHeader,
    AddFlow,
    FlowDetail,
  },
  setup(props, { root }) {
    const language = root.$store.state.locale;
    const lang = _.get(LANGUAGE_CODE, `${language}`, 'ja');

    const tradingId = computed(() => root.$route?.params.tradingId);
    const tradingFlowId = computed(() => root.$route?.params.tradingFlowId);
    const isNew = computed(
      () => tradingId.value === 'new' || tradingFlowId.value === 'new',
    );

    const breadcrumbs = computed(() => [
      { label: root.$t('BreadCrumbs.Dashboard'), to: '/' },
      {
        label: root.$t('BreadCrumbs.Trading List'),
        to:
          tradingId.value === 'new'
            ? '/trading/'
            : `/trading/?fid=${tradingId.value}`,
      },
      { label: lang === 'ja' ? 'フロー/プロセス一覧' : 'Flow / Process List' },
    ]);

    /* ========== Methods ========== */

    const historyBack = () => {
      // props.onToggleCollapse(false);
      window.history.back();
    };

    return {
      isNew,
      breadcrumbs,
      historyBack,
    };
  },
});
</script>
<style>
.route-TradingDetailV3 .el-main {
  background-color: #fff;
  padding: 0px !important;
  overflow-y: scroll;
}
</style>
